/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { updateCartLineDate, UpdateDateParams } from "@tKgpco/Services/UpdateCartLineDateService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = UpdateDateParams & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorials>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const updateCartLinesDateFn: HandlerType = async props => {
    try {
        await updateCartLineDate(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, updateCartLinesDateFn, ExecuteOnSuccess];

const updateCartLinesDate = createHandlerChainRunner(chain, "updateCartLinesDate");
export default updateCartLinesDate;
